import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { adminLogin, adminLogout, getAdminSession } from "../lib/api.js";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getAdminSession()
      .then(({ data }) => active && setUser(data))
      .catch(() => active && setUser(null))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const value = useMemo(() => ({
    user,
    loading,
    async login(credentials) {
      const { data } = await adminLogin(credentials);
      setUser(data);
      return data;
    },
    async logout() {
      await adminLogout().catch(() => null);
      setUser(null);
    },
  }), [user, loading]);

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
}

export function useAdmin() {
  const context = useContext(AdminContext);
  if (!context) throw new Error("useAdmin doit être utilisé dans AdminProvider.");
  return context;
}
